import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31 24.497v6.5H5v-6.5H.667v6.5A4.346 4.346 0 0 0 5 35.331h26a4.346 4.346 0 0 0 4.333-4.334v-6.5zm-2.167-8.666-3.055-3.055-5.611 5.59V.664h-4.334v17.702l-5.611-5.59-3.055 3.055L18 26.664z"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
